import {
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Tabs,
  Tab,
  Box,
  Typography,
  Stack
} from "@mui/material";
import { Autocomplete } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  HOSTNAME,
  INTRANETHOSTNAME,
  REPORT_HOSTNAME,
} from "../../../common-utilities/utils/end-points";
import { REST_URLS } from "../../../common-utilities/utils/end-points/pl-report";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import "./index.scss";
import { tokenMainKeys, appSlugs } from "../../../../utils/constants";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import ClearIcon from "@mui/icons-material/Clear";
import {
  CIRCLE_LIST,
  REGIONS_LIST,
} from "../../../store-master/components/store-master/config";
import DownloadIcon from "@mui/icons-material/Download";
import SalesSummary from "./summary.js";
import SalesTrends from "./trends.js";
import { COHORT_KEYS, METRIC_KEYS } from "./helper.js";
import MultiSelectAutoComplete from "../../../common-utilities/components/mutli-select-autocomplete/MultiSelectAutocomplete.js";
import FileUpload from "../../../common-utilities/core/file-uploader/index.js";
import { toast } from "react-toastify";
import { downloadFileFromUrl } from "../../utils/common-utils.js";
import { getOfflineData } from "../../../operation-kpi/utils/offline-services.js";

const SCOPE_FILTER_TYPES = [
  { id: "All India", label: "All India", allowedRoles: [""] },
  { id: "region", label: "Region", allowedRoles: [] },
  { id: "circle", label: "Circle", allowedRoles: [] },
];

const SELECT_SCOPE_FILTER_TYPES = [
  // { id: "All India", label: "All India", allowedRoles:[""] },
  { id: "type", label: "Type", allowedRoles: [] },
  { id: "priceCohort", label: "Cohort", allowedRoles: [] },
  { id: "region", label: "Region", allowedRoles: [] },
  { id: "tier", label: "Tier", allowedRoles: [] },
  { id: "circle", label: "Circle", allowedRoles: [] },
  { id: "city", label: "City", allowedRoles: [] },
  { id: "format", label: "Format", allowedRoles: [] },
  { id: "opsManager", label: "Ops Manager", allowedRoles: [] },
  { id: "am", label: "Area Manager", allowedRoles: [] },
  { id: "storeCode", label: "Store Code", allowedRoles: [] },
  { id: "storeOpeningDate", label: "Store Opening Date", allowedRoles: [] },
  // { id: "tier", label: "Tier", allowedRoles: [] },
];

const Sales = ({
  token = tokenMainKeys.plReport,
  slug = appSlugs.plReport,
}) => {
  const userDetails = getOfflineData("user", token) || {};
  const { role = "" } = userDetails;
  const [dateRanges, setDateRanges] = useState({});
  const [areaManagers, setAreaManagers] = useState([]);
  const [opsList, setOpsList] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [isCallApi, setIsCallApi] = useState(true);

  const [filterOptions, setFilterOptions] = useState({
    storeCode: [],
    type: [
      { label: "COCO Acquired", value: "COCO_ACQUIRED" },
      { label: "COCO Built", value: "COCO_BUILT" },
    ],
    region: REGIONS_LIST,
    city: [],
    circle: [],
    tier: [],
    format: [],
    selectedFilters: [],
  });

  const [filters, setFilters] = useState({
    page: 1,
    selectedFilters: [],
    scopeValues: {},
    scope: [SCOPE_FILTER_TYPES[0]],
    scopeValue: [],
    circles: [],
    regions: [],
    cohortTypes: COHORT_KEYS,
    metric: ["ADS (INR)"],
    selectScopes: [],
    selectScopeValues: {},
  });

  const [searchTrigger, setSearchTrigger] = useState(false);
  const [isDownload, setIsDownload] = useState(false);
 const [storeOpeningStart, setStoreOpeningStart] = useState(null);
  const [storeOpeningEnd, setStoreOpeningEnd] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);

  const getSelectedFiltersPayload = (isPassManagerId = false) => {
    const params = {};

    filters.selectedFilters.forEach((filter) => {
      const { id, value } = filter;
      if (id !== "storeCode" && id !== "format") {
        if (Array.isArray(value)) {
          const mappedValues = value
            .map((v) => {
              if (isPassManagerId && (id === "am" || id === "opsManager")) {
                return v?.id ?? v;
              }
              return v?.value ?? v;
            })
            .filter(Boolean);

          if (mappedValues.length > 0) {
            params[id] = mappedValues;
          }
        } else if (value !== undefined && value !== null && value !== "") {
          let val;
          if (isPassManagerId && (id === "am" || id === "opsManager")) {
            val = value?.id ?? value;
          } else {
            val = value?.value ?? value;
          }

          if (val !== undefined && val !== null && val !== "") {
            params[id] = val;
          }
        }
      }
    });

    return params;
  };
  const loadFilterOptions = () => {
    const selectedFilters = getSelectedFiltersPayload();
    const payload = payloadHandler();
    invokeApi(
      HTTP_METHODS.POST,
      `${REPORT_HOSTNAME}${REST_URLS.PL_FFILTERS}`,
      payload,
      selectedFilters,
      null,
      slug,
      token
    )
      .then((res) => {
        if (!res.message) {
          const storeCode = res?.storeName?.map((ele) => ({
            label: ele.storeName,
            value: ele.storeCode,
          }));
          const city = res?.city?.map((ele) => ({ label: ele, value: ele }));
          const circle = res?.circle?.map((ele) => ({
            label: ele,
            value: ele,
          }));
          const tier = res?.tier?.map((ele) => ({ label: ele, value: ele }));
          const format = res?.format?.map((ele) => ({
            label: ele,
            value: ele,
          }));

          const priceCohort = res?.priceCohort?.map((ele) => ({
            label: ele,
            value: ele,
          }));

          setFilterOptions((prevVal) => ({
            ...prevVal,
            storeCode,
            city,
            circle,
            tier,
            format,
            priceCohort,
          }));
        }
      })
      .catch((err) => console.error(err));
  };
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const loadManager = () => {
    const selectedFilters = getSelectedFiltersPayload(true);
    const payload = payloadHandler();
    invokeApi(
      HTTP_METHODS.POST,
      `${HOSTNAME}${REST_URLS.MANAGER_LIST}`,
      payload,
      {
        additionalRole: "am",
        ...selectedFilters,
      }
    ).then((response) => {
      if (response?.length > 0) {
        setAreaManagers(
          response.map((r) => {
            return {
              ...r,
              label: r.name,
              value: r.name,
            };
          })
        );
      }
    });
  };
  const loadOpsManager = () => {
    const selectedFilters = getSelectedFiltersPayload(true);
    const payload = payloadHandler();

    invokeApi(
      HTTP_METHODS.POST,
      `${INTRANETHOSTNAME}${REST_URLS.MANAGER_LIST}`,
      payload,
      { additionalRole: "opsManager", ...selectedFilters }
    )
      .then((res) => {
        if (!res.message) {
          const users =
            res?.map?.((item) => {
              return {
                label: `${item?.email ? item?.email + "- " : ""}${item.name}`,
                value: item.id,
              };
            }) || [];
          setOpsList(users);
        }
      })
      .catch((err) => {
        console.log("Error occcurred getting user list", err);
      });
  };
  const payloadHandler = () => {
    let payload = {};
    if (Object.keys(filters.selectScopeValues).length > 0) {
      Object.keys(filters.selectScopeValues).forEach((key) => {
        payload[key?.toLowerCase()] = filters.selectScopeValues[key].map(
          (v) => v.value ?? v
        );
      });
    }else if (filters?.scopeValues?.["Store Opening Date"]) {
      payload.storeOpeningDate = filters.scopeValues["Store Opening Date"];
    }
    return payload;
  };

  const downloadInputFile = () => {
    let params = {};
    let payload = {
      viewFilters: {},
    };

    if (dateRanges?.startMonth && dateRanges?.startYear) {
      params.date = `${dateRanges?.startMonth}/01/${dateRanges?.startYear}`;
    }

    (filters.selectedFilters || []).forEach((filter) => {
      if (Array.isArray(filter.value) && filter.value.length > 0) {
        payload[filter.id] = filter.value.map((v) => v.value ?? v);
      }
    });

    if (filters?.scope?.find((f) => f.id === "All India")) {
      payload.viewFilters["All India"] = ["All India"];
    }

    if (filters?.circles?.length > 0) {
      payload.viewFilters["circles"] = filters.circles.map((v) => v.value ?? v);
    }
    if (filters?.regions?.length > 0) {
      payload.viewFilters["regions"] = filters?.regions.map(
        (v) => v.value ?? v
      );
    }

    if (filters?.scope?.length === 0) {
      delete payload.viewFilters;
    }

    if (Object.keys(filters.selectScopeValues).length > 0) {
      Object.keys(filters.selectScopeValues).forEach((key) => {
        payload[key?.toLowerCase()] = filters.selectScopeValues[key].map(
          (v) => v.value ?? v
        );
      });
    }

    payload["cohortTypes"] = filters?.cohortTypes?.map((v) => v.value ?? v) ?? [];
    payload["metric"] = filters?.metric?.map((v) => v.value ?? v) ?? [];
    params["isDownload"] = true;

    invokeApi(
      HTTP_METHODS.POST,
      `${REPORT_HOSTNAME}${REST_URLS.SALES_INPUT_FILE_SUMMARY}`,
      payload,
      params,
      null,
      slug,
      token
    )
      .then((response) => {
        if (response.message) {
          toast.error(response.message);
        }
        if (response.url) {
          downloadFileFromUrl(response.url);
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    if (isCallApi) {
      loadFilterOptions();
      loadManager();
      loadOpsManager();
    }
  }, [filters?.selectScopes, isCallApi]);

  useEffect(() => {
    if (!filters?.scope?.find((r) => r.id === "region")) {
      setFilters((prev) => ({
        ...prev,
        regions: [],
      }));
    }
    if (!filters?.scope?.find((r) => r.id === "circle")) {
      setFilters((prev) => ({
        ...prev,
        circles: [],
      }));
    }
  }, [filters?.scope]);

  return (
    <div className="sales-report-container">
      <div className="pl-filter-container">
        <Box
          sx={{
            border: "1px solid #e0e0e0",
            padding: "10px",
            borderRadius: "5px",
            paddingTop: "20px",
            position: "relative",
            display: "flex",
            gap: "10px",
          }}
        >
          <Typography
            variant="caption"
            sx={{
              position: "absolute",
              top: -8,
              left: 12,
              px: 0.5,
              background: "#f6f6f6",
              color: "#6b7280",
            }}
          >
            Select view
          </Typography>
          <MultiSelectAutoComplete
            label="Scope"
            options={SCOPE_FILTER_TYPES}
            value={filters?.scope || ""}
            setIsCallApiForView={() => {}}
            onChange={(newValue) => {
              setFilters((prev) => ({
                ...prev,
                scope: newValue,
              }));
            }}
          />

          {/* 🔹 Conditional Dropdowns */}
          {filters?.scope?.find((r) => r.id === "region") && (
            <MultiSelectAutoComplete
              label="Region"
              options={REGIONS_LIST}
              value={filters.regions}
              setIsCallApiForView={() => {}}
              onChange={(newValue) => {
                setFilters((prev) => ({
                  ...prev,
                  regions: newValue,
                }));
              }}
            />
          )}

          {filters?.scope?.find((r) => r.id === "circle") && (
            <MultiSelectAutoComplete
              label="Circle"
              disableCloseOnSelect
              options={CIRCLE_LIST}
              value={filters.circles}
              setIsCallApiForView={() => {}}
              onChange={(newValue) => {
                setFilters((prev) => ({
                  ...prev,
                  circles: newValue,
                }));
              }}
            />
          )}
          <MultiSelectAutoComplete
            label="Metrics"
            options={METRIC_KEYS.map((k) => {
              return { label: k, value: k };
            })}
            setIsCallApiForView={() => {}}
            value={filters.metric}
            onChange={(newValue) => {
              setFilters((prev) => ({
                ...prev,
                metric: newValue,
              }));
            }}
          />
          <MultiSelectAutoComplete
            label="Cohort"
            options={COHORT_KEYS.map((k) => {
              return {
                label: k,
                value: k,
              };
            })}
            value={filters.cohortTypes}
            onChange={(newValue) => {
              setFilters((prev) => ({
                ...prev,
                cohortTypes: newValue,
              }));
            }}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: "10px",
            border: "1px solid #e0e0e0",
            padding: "10px",
            borderRadius: "5px",
            paddingTop: "20px",
            position: "relative",
          }}
        >
          <Typography
            variant="caption"
            sx={{
              position: "absolute",
              top: -8,
              left: 12,
              px: 0.5,
              background: "#f6f6f6",
              color: "#6b7280",
            }}
          >
            Select Filter
          </Typography>
          {/* Existing Custom Filters */}
          <>
            <Autocomplete
              multiple
              size="small"
              sx={{ minWidth: 300 }}
              options={SELECT_SCOPE_FILTER_TYPES}
              value={filters.selectScopes}
              onChange={(event, newValue) => {
                setFilters((prev) => {
                  const newScope = newValue || [];
                  const keptScopeValues = Object.fromEntries(
                    Object.entries(prev.selectScopeValues || {}).filter(
                      ([key]) => newScope.some((s) => s.label === key)
                    )
                  );
                  return {
                    ...prev,
                    selectScopes: newScope,
                    selectScopeValues: keptScopeValues,
                  };
                });
              }}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) =>
                option.label === value.label
              }
              renderInput={(params) => (
                <TextField {...params} label="Filters" variant="outlined" />
              )}
            />
            {(filters.selectScopes || []).map((scopeObj) => {
              const scope = scopeObj.label;
              const currentValue = filters.selectScopeValues[scope] || [];
     if (scope === "Store Opening Date") {
              return (
                <Stack direction="row" spacing={1} key={scope} alignItems="center">
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      label="Start Date"
                      value={storeOpeningStart}
                      onChange={(value) => {
                        setStoreOpeningStart(value);
                        const startStr = value ? value.format("YYYY-MM-DD") : null;
                        const endStr = storeOpeningEnd
                          ? storeOpeningEnd.format("YYYY-MM-DD")
                          : null;

                        // only update when both exist and valid
                        if (startStr && endStr) {
                          if (moment(endStr).isBefore(moment(startStr))) {
                            toast.error("End date must be after start date");
                            return;
                          }
                          const dateObj = { startDate: startStr, endDate: endStr };
                          setFilters((prev) => ({
                            ...prev,
                            scopeValues: {
                              ...prev.scopeValues,
                              [scope]: dateObj,
                            },
                          }));
                          setIsCallApi(true);
                        } else {
                          // clear incomplete range
                          setFilters((prev) => ({
                            ...prev,
                            scopeValues: {
                              ...prev.scopeValues,
                              [scope]: {},
                            },
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          sx={{ minWidth: 150 }}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <InputAdornment position="end">
                                {storeOpeningStart && (
                                  <IconButton
                                    onClick={() => {
                                      setStoreOpeningStart(null);
                                      setFilters((prev) => ({
                                        ...prev,
                                        scopeValues: {
                                          ...prev.scopeValues,
                                          [scope]: {},
                                        },
                                      }));
                                    }}
                                    sx={{ padding: "0px" }}
                                  >
                                    <ClearIcon fontSize="small" />
                                  </IconButton>
                                )}
                                {params.InputProps.endAdornment}
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>

                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      label="End Date"
                      value={storeOpeningEnd}
                      minDate={storeOpeningStart}
                      onChange={(value) => {
                        setStoreOpeningEnd(value);
                        const startStr = storeOpeningStart
                          ? storeOpeningStart.format("YYYY-MM-DD")
                          : null;
                        const endStr = value
                          ? value.format("YYYY-MM-DD")
                          : null;

                        if (startStr && endStr) {
                          if (moment(endStr).isBefore(moment(startStr))) {
                            toast.error("End date must be after start date");
                            return;
                          }
                          const dateObj = { startDate: startStr, endDate: endStr };
                          setFilters((prev) => ({
                            ...prev,
                            scopeValues: {
                              ...prev.scopeValues,
                              [scope]: dateObj,
                            },
                          }));
                          setIsCallApi(true);
                        } else {
                          setFilters((prev) => ({
                            ...prev,
                            scopeValues: {
                              ...prev.scopeValues,
                              [scope]: {},
                            },
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          sx={{ minWidth: 150 }}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <InputAdornment position="end">
                                {storeOpeningEnd && (
                                  <IconButton
                                    onClick={() => {
                                      setStoreOpeningEnd(null);
                                      setFilters((prev) => ({
                                        ...prev,
                                        scopeValues: {
                                          ...prev.scopeValues,
                                          [scope]: {},
                                        },
                                      }));
                                    }}
                                    sx={{ padding: "0px" }}
                                  >
                                    <ClearIcon fontSize="small" />
                                  </IconButton>
                                )}
                                {params.InputProps.endAdornment}
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
              );
            }
              const optionsMap = {
                Region: filterOptions.region || [],
                Circle: filterOptions.circle || [],
                "Area Manager": areaManagers,
                "Ops Manager": opsList,
                "Store Code": filterOptions.storeCode || [],
                City: filterOptions.city || [],

                Format: filterOptions.format || [],
                Type: filterOptions.type || [],
                Cohort: filterOptions.priceCohort || [],
                Tier: filterOptions.tier || [],
              };

              const allOptions = optionsMap[scope] || [];
              return (
                <MultiSelectAutoComplete
                  key={scope}
                  label={scope}
                  options={allOptions}
                  value={currentValue}
                  setIsCallApiForView={setIsCallApi}
                  onChange={(newValue) => {
                    setFilters((prev) => ({
                      ...prev,
                      selectScopeValues: {
                        ...prev.selectScopeValues,
                        [scope]: newValue,
                      },
                    }));
                  }}
                />
              );
            })}
          </>
          {/* Date Picker */}
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
              label={"Select Month and Year"}
              views={["month", "year"]}
              minDate={moment("2000-01-01")}
              maxDate={moment("2099-12-31")}
              disabled={tabIndex === 3}
              value={startDate}
              onChange={(value) => {
                if (value) {
                  const year = value.year();
                  const month = value.month() + 1;

                  setDateRanges((prevVal) => ({
                    ...prevVal,
                    startMonth: month,
                    startYear: year,
                  }));
                  setStartDate(value);
                } else {
                  setStartDate(null);
                }
              }}
              renderInput={(params) => (
                <TextField
                  className="new-textfield"
                  size="small"
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <InputAdornment position="end">
                        {startDate && (
                          <IconButton
                            onClick={() => {
                              setStartDate(null);
                              delete dateRanges?.startMonth;
                              delete dateRanges?.startYear;
                            }}
                            sx={{ padding: "0px" }}
                          >
                            <ClearIcon fontSize="small" />
                          </IconButton>
                        )}
                        {params.InputProps.endAdornment}
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
          </LocalizationProvider>
        </Box>

        <Button
          variant="contained"
          onClick={() => {
            setSearchTrigger(true);
          }}
        >
          SEARCH
        </Button>
        <Button
          variant="outlined"
          onClick={downloadInputFile}
          color="info"
          endIcon={<DownloadIcon />}
        >
          Download Report
        </Button>
        {role?.toLowerCase() === "admin" && (
          <FileUpload
            uploadText="Upload"
            id="sales-uplaod"
            clsName="pl-spidle-upload-file"
            color="warning"
            size="medium"
            url={`${REPORT_HOSTNAME}${REST_URLS.SALES_UPLOAD}`}
            callBack={() => setSearchTrigger(true)}
          />
        )}
      </div>

      {/* Tabs */}
      <Box sx={{ mt: 2, mb: 0 }}>
        <Tabs value={tabIndex} onChange={handleTabChange}>
          <Tab label="Summary" />
          <Tab label="Trends" />
        </Tabs>
      </Box>

      {tabIndex === 0 && (
        <Box>
          <SalesSummary
            filters={filters}
            setFilters={setFilters}
            dateRanges={dateRanges}
            slug={slug}
            token={token}
            tabIndex={tabIndex}
            searchTrigger={searchTrigger}
            isDownload={isDownload}
            setIsDownload={setIsDownload}
            setSearchTrigger={setSearchTrigger}
          />
        </Box>
      )}

      {tabIndex === 1 && (
        <Box>
          <SalesTrends
            filters={filters}
            setFilters={setFilters}
            dateRanges={dateRanges}
            slug={slug}
            token={token}
            tabIndex={tabIndex}
            searchTrigger={searchTrigger}
            isDownload={isDownload}
            setIsDownload={setIsDownload}
            setSearchTrigger={setSearchTrigger}
          />
        </Box>
      )}
    </div>
  );
};

export default Sales;
